var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 7.83178C10.4437 7.67947 10.3904 7.53195 10.293 7.41485L7.02664 3.50938C6.91575 3.37645 6.7566 3.29302 6.5842 3.27743C6.4118 3.26185 6.24027 3.31538 6.10734 3.42627C5.97441 3.53715 5.89098 3.6963 5.87539 3.86871C5.85981 4.04111 5.91335 4.21264 6.02423 4.34557L8.95085 7.83443L6.14095 11.3335C6.08692 11.4003 6.04662 11.4771 6.02237 11.5595C5.99811 11.6419 5.99038 11.7283 5.99962 11.8137C6.00886 11.899 6.03488 11.9818 6.0762 12.0571C6.11751 12.1324 6.17331 12.1988 6.24037 12.2525C6.3075 12.3121 6.38621 12.3571 6.47158 12.3849C6.55694 12.4126 6.64711 12.4224 6.73645 12.4137C6.82578 12.405 6.91235 12.3779 6.99073 12.3342C7.06911 12.2904 7.13761 12.231 7.19194 12.1595L10.3336 8.24266C10.4152 8.12186 10.4539 7.9772 10.4436 7.83178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0545d9ce8d8abfdc09381b960c93c4d5.svg";
export { ForwardRef as ReactComponent };